import { Link } from "react-router-dom"

import {
  batteryContractPath,
  batteryFinancingStatusPath,
  batteryProposalPath,
} from "../../setup/setup-steps"
import { APPLICATION_STATUS_ACTION_LABEL } from "../application-status-labels"
import type { BatteryDrawerLaunchState } from "../battery-drawer-launch"
import type { BatteryFinancingLock } from "./use-battery-financing-lock"

/**
 * Explains a server-side financing lock inside a Setup step. Concert status
 * lives under Contract; Sungage uses the financing-status drawer.
 */
export function FinancingLockNotice({
  proposalId,
  lock,
}: {
  proposalId: string
  lock: Pick<BatteryFinancingLock, `locked` | `reason` | `statusKind`>
}): JSX.Element | null {
  if (!lock.locked) {
    return null
  }
  const to =
    lock.statusKind === `contract`
      ? batteryContractPath(proposalId)
      : batteryFinancingStatusPath(proposalId)
  return (
    <p
      role="status"
      data-testid="battery-financing-locked"
      className="flex flex-wrap items-baseline gap-x-3 gap-y-1 rounded-md border border-bp-gold/40 bg-bp-gold/10 px-3 py-2 text-[length:var(--step--2)] text-bp-gold"
    >
      <span>{lock.reason}</span>
      <Link
        to={to}
        state={
          {
            returnTo: batteryProposalPath(proposalId),
          } satisfies BatteryDrawerLaunchState
        }
        className="font-semibold text-bp-text underline-offset-2 hover:underline"
      >
        {APPLICATION_STATUS_ACTION_LABEL}
      </Link>
    </p>
  )
}
